import { render, staticRenderFns } from "./PayrollEmployeeBadges.vue?vue&type=template&id=93c9f47e&scoped=true&"
import script from "./PayrollEmployeeBadges.vue?vue&type=script&lang=js&"
export * from "./PayrollEmployeeBadges.vue?vue&type=script&lang=js&"
import style0 from "./PayrollEmployeeBadges.vue?vue&type=style&index=0&id=93c9f47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c9f47e",
  null
  
)

export default component.exports